import { render } from "./ArgonPaginationItem.vue?vue&type=template&id=4e219e8c"
import script from "./ArgonPaginationItem.vue?vue&type=script&lang=js"
export * from "./ArgonPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__